import MessageApi from '../../../../api/inbox/message';

export default {
  async forwardMessage(_, { conversationId, messageId, contacts }) {
    try {
      await MessageApi.forwardMessage(conversationId, messageId, contacts);
    } catch (error) {
      // ignore error
    }
  },

  async forwardMessages(_, { conversationId, messageIds, contacts }) {
    try {
      await MessageApi.forwardMessages(conversationId, messageIds, contacts);
      return { success: true, count: messageIds.length };
    } catch (error) {
      return { success: false, error };
    }
  },
};
